export const FETCH_ALL_MEDICINES_TABLE_BEGIN= 'FETCH_ALL_MEDICINES_TABLE_BEGIN';
export const FETCH_ALL_MEDICINES_TABLE_SUCCESS='FETCH_ALL_MEDICINES_TABLE_SUCCESS';
export const FETCH_ALL_MEDICINES_TABLE_ERROR='FETCH_ALL_MEDICINES_TABLE_ERROR';

